import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import tenantsContext from '../../context/tenants/tenantsContext';
import usuariosContext from '../../context/usuarios/usuariosContext';

function Tablero() {
    const tContext = useContext(tenantsContext);
    const { tenants, getAllTenants, getTenantStats, stats } = tContext;

    const uContext = useContext(usuariosContext);
    const { usuarios, getAllUsers } = uContext;

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await getAllTenants();
            await getAllUsers();
            await getTenantStats();
            setLoading(false);
        };
        fetchData();
    }, []);

    const enabledTenants = tenants?.filter(t => t.enabled) || [];
    const disabledTenants = tenants?.filter(t => !t.enabled) || [];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            <Typography variant="h4" gutterBottom sx={{ color: '#3d4d87', fontWeight: 'bold' }}>
                Tablero de Control
            </Typography>

            <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ backgroundColor: '#3d4d87', color: 'white' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h3">{tenants?.length || 0}</Typography>
                                    <Typography variant="body2">Total Tenants</Typography>
                                </Box>
                                <BusinessIcon sx={{ fontSize: 50, opacity: 0.5 }} />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ backgroundColor: '#28a745', color: 'white' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h3">{enabledTenants.length}</Typography>
                                    <Typography variant="body2">Tenants Activos</Typography>
                                </Box>
                                <CheckCircleIcon sx={{ fontSize: 50, opacity: 0.5 }} />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ backgroundColor: '#dc3545', color: 'white' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h3">{disabledTenants.length}</Typography>
                                    <Typography variant="body2">Tenants Inactivos</Typography>
                                </Box>
                                <CancelIcon sx={{ fontSize: 50, opacity: 0.5 }} />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ backgroundColor: '#17a2b8', color: 'white' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h3">{usuarios?.length || 0}</Typography>
                                    <Typography variant="body2">Total Usuarios</Typography>
                                </Box>
                                <PeopleIcon sx={{ fontSize: 50, opacity: 0.5 }} />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom sx={{ color: '#3d4d87' }}>
                                Tenants Recientes
                            </Typography>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Codigo</TableCell>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Estado</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tenants?.slice(0, 5).map((tenant) => (
                                            <TableRow key={tenant._id}>
                                                <TableCell>{tenant.codTenant}</TableCell>
                                                <TableCell>{tenant.name}</TableCell>
                                                <TableCell>
                                                    <Chip
                                                        size="small"
                                                        label={tenant.enabled ? 'Activo' : 'Inactivo'}
                                                        color={tenant.enabled ? 'success' : 'error'}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom sx={{ color: '#3d4d87' }}>
                                Usuarios Recientes
                            </Typography>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Usuario</TableCell>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Estado</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {usuarios?.slice(0, 5).map((user) => (
                                            <TableRow key={user._id}>
                                                <TableCell>{user.userName}</TableCell>
                                                <TableCell>{user.fullName}</TableCell>
                                                <TableCell>
                                                    <Chip
                                                        size="small"
                                                        label={user.enabled ? 'Activo' : 'Inactivo'}
                                                        color={user.enabled ? 'success' : 'error'}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Tablero;
